import AppState from "../state";

// Consultas consolidadas da tela "Visão de Pessoas" e as importações em massa.
// Ficam num módulo separado de funcionarios.js de propósito: aqui tudo é visão
// agregada de várias pessoas, lá é a ficha de uma pessoa só.
const baseUrl = `${AppState.serverAddr}/funcionarios`;

const tratarResposta = response => {
  if (!response.ok) {
    return response.json().then(json => {
      const error = new Error(response.status);
      error.response = json;
      throw error;
    });
  }

  return response.json();
};

const buscar = (arquivo, params) => {
  const sufixo = params
    ? `?json=${encodeURIComponent(JSON.stringify(params))}`
    : "";

  return fetch(`${baseUrl}/${arquivo}${sufixo}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: AppState.token
    }
  }).then(tratarResposta);
};

const enviar = (arquivo, dados) => {
  return fetch(`${baseUrl}/${arquivo}`, {
    method: "POST",
    headers: {
      Authorization: AppState.token
    },
    body: JSON.stringify(dados)
  }).then(tratarResposta);
};

// ano opcional: sem ele a foto é de hoje; com ele, de 31/12 daquele ano.
const getVisaoFerias = (status, ano) =>
  buscar("GetVisaoFerias.php", ano ? { status, ano } : { status });
const getVisaoDecimoTerceiro = (ano, status) =>
  buscar("GetVisaoDecimoTerceiro.php", { ano, status });
const getVisaoSalarios = (status, competencia) =>
  buscar("GetVisaoSalarios.php", competencia ? { status, competencia } : { status });
// competencia opcional (AAAA-MM): sem ela o servidor devolve o mes mais
// recente que tem lancamento daquele assunto, junto com a lista de meses.
const getVisaoBeneficios = (status, competencia) =>
  buscar("GetVisaoBeneficios.php", competencia ? { status, competencia } : { status });

// Rescisão não recebe filtro de ativo/desligado: por definição só há linha para
// quem foi desligado. O ano é opcional — sem ele vem o histórico inteiro.
const getVisaoRescisao = ano => buscar("GetVisaoRescisao.php", ano ? { ano } : null);

// Saldo de FGTS informado + depósitos lançados depois dele. Só CLT.
const getVisaoFgts = status => buscar("GetVisaoFgts.php", { status });

// validarApenas = true devolve a prévia (o que entraria e o que seria recusado)
// sem gravar nada. É o passo obrigatório antes de confirmar a importação.
const importarFerias = (linhas, validarApenas) =>
  enviar("ImportFerias.php", { linhas, validar_apenas: !!validarApenas });

const importarSalarios = (linhas, validarApenas) =>
  enviar("ImportSalarios.php", { linhas, validar_apenas: !!validarApenas });

const importarFgts = (linhas, validarApenas) =>
  enviar("ImportFgts.php", { linhas, validar_apenas: !!validarApenas });

// Pedido de vale-transporte do mês (tabela vt_pedido). Gerar recalcula todo
// mundo pelos dias úteis informados, mantendo o que foi ajustado à mão.
const getPedidoVT = competencia => buscar("GetPedidoVT.php", { competencia });
const gerarPedidoVT = (competencia, diasUteis) =>
  enviar("GerarPedidoVT.php", { competencia, dias_uteis: diasUteis });
// alteracoes: dias_trabalhados, valor_riocard, valor_jae, valor_segunda_via,
// observacao ou { recalcular: true } para voltar ao cálculo do cadastro.
const editarItemVT = (competencia, cpf, alteracoes) =>
  enviar("EditarItemVT.php", { competencia, cpf_funcionario: cpf, ...alteracoes });

// Pedido de vale-alimentação/refeição do mês (tabela va_pedido). feriados =
// lista 'AAAA-MM-DD' do mês, para não descontar feriado duas vezes.
const getPedidoVA = competencia => buscar("GetPedidoVA.php", { competencia });
const gerarPedidoVA = (competencia, diasUteis, feriados) =>
  enviar("GerarPedidoVA.php", { competencia, dias_uteis: diasUteis, feriados: feriados || [] });
// alteracoes: dias_trabalhados, valor_segunda_via, observacao ou
// { recalcular: true }.
const editarItemVA = (competencia, cpf, alteracoes) =>
  enviar("EditarItemVA.php", { competencia, cpf_funcionario: cpf, ...alteracoes });

export default {
  getPedidoVA,
  gerarPedidoVA,
  editarItemVA,
  getPedidoVT,
  gerarPedidoVT,
  editarItemVT,
  getVisaoFerias,
  getVisaoDecimoTerceiro,
  getVisaoSalarios,
  getVisaoBeneficios,
  getVisaoRescisao,
  getVisaoFgts,
  importarFerias,
  importarSalarios,
  importarFgts
};
